import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-gps-fixed",
  templateUrl: "./med-icon-gps-fixed.component.html",
})
export class MedIconGpsFixedComponent extends SvgMixinComponent {}
